import { render, staticRenderFns } from "./XzqxSchoolList.vue?vue&type=template&id=25fbd83d&scoped=true&"
import script from "./XzqxSchoolList.vue?vue&type=script&lang=js&"
export * from "./XzqxSchoolList.vue?vue&type=script&lang=js&"
import style0 from "./XzqxSchoolList.vue?vue&type=style&index=0&id=25fbd83d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fbd83d",
  null
  
)

export default component.exports